import _ from 'lodash'

export const transactionTypesFormatter = {
    formatTransactionTypeStats,
    formatTransactionTypes,
    formatTransactionTypeStatuses
};

function formatTransactionTypeStats(data){
    const dates = _.sortBy(_.uniq(_.map(data, item=>item.gen_date)), (date)=>new Date(date)),
        silos = _.uniq(_.map(data, item=>item.silo)),
        transactionTypes = _.map(transactionTypesEnum, item=>item.value);
        
    let result = [];

    
    for (let transactionType of transactionTypes) {
        for(let siloID in silos) {
            const silo = silos[siloID],
                transactionTypeID = _.find(transactionTypesEnum, {value: transactionType}).vend_id;
            
            let item = {silo, transactionType, siloID, transactionTypeID},
                foundDays = 0,
                foundTotal = 0;
                
            for(let gen_date of dates) {
                let record = _.find(data, {silo, transactionType, gen_date});
                    
                if(record) {
                    const { rpt_rows: rows } = record;
                    foundDays++;
                    foundTotal += rows;
                    item[gen_date] = rows;
                }
                else
                    item[gen_date] = null; 
            }
            
            item.average = foundDays ? Math.round(foundTotal / foundDays) : 0;
            result.push(item);
        }
    }
    
    return { result, dates};
}


function formatTransactionTypeStatuses(stats, statuses) {
    for(let status of statuses) {
        let stat = _.find(stats, {transactionTypeID: status.transactionType_id, silo: status.silo_code});
        if(stat)
            stat.status = status.status;
    }
    return stats;
}


function _formatTransactionTypes(transactionTypes) {
    return _.groupBy(_.map(transactionTypes.result, (i)=>({
        label: i.name,
        value: i.name,
        group: i.group_name
    })), 'group');
}



function formatTransactionTypes(transactionTypes) {
  const grouped = _.groupBy(
    _.orderBy(_.map(transactionTypes.result, t=>({
      label: t.label,
      value: `${t.group_name}~${t.value}`,
      group_name: t.group_name  
    })), 'popularity', 'asc'),
    'group_name'
  );
  console.log(grouped);
  return grouped;


}
